import React, { useState } from "react";
import Layout from "../form-layout";
import RejectionModal from "./rejection-modal";
import { checkImmediateRed } from "../../lib/eligibility";

// Standalone "Are you aged 18–84?" gate. Replaces the old confirmation-step.jsx, which
// bundled age together with UK-residency/accuracy — that language now lives in the
// final acknowledgement screen, matching the docs.
export default function AgeGate({ formData, setFormData, onBack, goToStep, isFirstStep }) {
  const [answer, setAnswer] = useState(formData.ageEligible || "");
  const [rejection, setRejection] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!answer) return;

    const nextFormData = { ...formData, ageEligible: answer };
    setFormData(nextFormData);
    localStorage.setItem("ageEligible", answer);

    const redFlag = checkImmediateRed(nextFormData);
    if (redFlag) {
      setRejection(redFlag);
      return;
    }

    goToStep("reasons");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack} isFirstStep={isFirstStep}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">Are you aged 18 – 84?</h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="flex items-center gap-8">
          {["Yes", "No"].map((option) => (
            <label key={option} className="inline-flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="ageEligible"
                checked={answer === option}
                onChange={() => setAnswer(option)}
                className="h-4 w-4 accent-[#35C3D9]"
              />
              <span>{option}</span>
            </label>
          ))}
        </div>

        <div className="flex justify-start mt-2">
          <button
            type="submit"
            disabled={!answer}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!answer ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next
          </button>
        </div>
      </form>

      {rejection && <RejectionModal onClose={() => setRejection(null)} />}
    </Layout>
  );
}
